import { helpers } from "vuelidate/lib/validators";

// function log(toLog) {
//     console.log(toLog);
//     return true;
// }

function decimalPlacesCount(value) {
    let array = String(value).split('.');
    return array.length > 1 ? array[1].length : 0;
}

export const contains = (param) =>
    helpers.withParams(
        { type: 'contains', value: param },
        (value) => !helpers.req(value) || !String(value).includes(param)
    );

export const maxDecimalPlaces = (maxPlaces) =>
    helpers.withParams(
        { type: 'maxDecimalPlaces', value: maxPlaces },
        (value) => !helpers.req(value) || decimalPlacesCount(value) <= maxPlaces
    );

